import React from 'react';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';

interface Props {
  onExecute: () => void;
}

function EditButton({ onExecute }: Props) {
  return (
    <IconButton onClick={onExecute} title="Zeile bearbeiten">
      <EditIcon />
    </IconButton>
  );
}
export default EditButton;
